var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.id)?_c('spreadsheet',{ref:"sp",attrs:{"opts":_vm.opts},on:{"ready":_vm.onDataReady}}):_c('detail',{attrs:{"opts":_vm.opts,"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }